import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { ViewportScroller } from "@angular/common";
import { Component, ContentChild, HostListener, Input } from "@angular/core";

import { SidebarComponent } from "../sidebar/sidebar.component";
import { PageBodyComponent } from "./page-body.component";
import { PageHeaderComponent } from "./page-header.component";

@Component({
  selector: "ta-page-container",
  templateUrl: "page-container.template.html",
  styles: [
    `
      [content-width] {
        width: 960px;
      }

      [min-content-width] {
        min-width: 960px;
      }

      [min-body-height] {
        min-height: 320px;
      }
    `
  ]
})
export class PageContainerComponent {
  @ContentChild(PageHeaderComponent, { static: false })
  headerRef: PageHeaderComponent;

  @ContentChild(PageBodyComponent, { static: false })
  bodyRef: PageBodyComponent;

  @ContentChild(SidebarComponent, { static: false })
  sidebarRef: SidebarComponent;

  @Input()
  sidebarProjectedIn: boolean = false;

  private _hideBody: boolean;
  scrollY: number = this.getScrollY();

  @Input()
  get hideBody(): boolean {
    return this._hideBody;
  }
  set hideBody(value: boolean) {
    this._hideBody = coerceBooleanProperty(value);
  }

  // @ts-ignore unused onScroll
  @HostListener("window:scroll") private onScroll(): void {
    this.scrollY = this.getScrollY();
  }

  constructor(private scroller: ViewportScroller) {}

  get display(): "grid" | "block" {
    return document.querySelector("exp-sidebar") != null ? "block" : "grid";
  }

  get showBody(): boolean {
    return !this.hideBody && this.bodyRef != null;
  }

  get showSidebar(): boolean {
    return this.sidebarProjectedIn || this.sidebarRef != null;
  }

  private getScrollY(): number {
    const [, y] = this.scroller.getScrollPosition();
    return y;
  }
}
